module.exports = __webpack_public_path__ + "static/media/community_active.f916270b.svg";